export default __webpack_public_path__ + "static/media/TZ.6fd1271e.svg";